/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { HotColumn, HotTable } from "@handsontable/react";
import "handsontable/dist/handsontable.full.min.css";
import { deDE, registerLanguageDictionary } from "handsontable/i18n";
import { registerAllModules } from "handsontable/registry";
import { useContext, useEffect, useRef, useState, useMemo } from "react";
import { useQueryClient } from "react-query";
import { useFetchAllCategories } from "src/enitities/Category/lib/hooks/useCategoryQuery";
import { useFetchAllManufacturers } from "src/enitities/Manufacture/lib/hooks/useManufactureQuery";
import {
  useFetchAllNomenclature,
  useFetchCreateNomenclature,
  useFetchDeleteNomenclature,
  useFetchEditNomenclature,
} from "src/enitities/Nomenclature/lib/hooks/useNomenclatureQuery";
import {
  useFetchAllPrices,
  useFetchCreatePrice,
  useFetchDeletePrices,
  useFetchEditPrice,
} from "src/enitities/Price/lib/hooks/usePriceQuery";
import { useFetchAllPricesType } from "src/enitities/PriceType/lib/hooks/usePriceTypeQuery";
import { useFetchAllUnits } from "src/enitities/Unit/lib/hooks/useUnitQuery";
import { PricesHandsontableContext } from "src/shared/lib/hooks/context/getPricesHandsontableContext";
import { message, Collapse, Form, Input, Select, Button } from "antd";

import {
  ChangeTypes,
  convertArrayToObject,
  convertUnitsToObjectByValue,
  getChangeType,
  getPreparePrices,
  getPriceListForCreateFetch,
  getPriceListForEditFetch,
  reversedObj,
} from "./utils";

import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { apiRequests } from "src/shared/api/api";
import { useVirtualization } from "./hooks";

registerAllModules();
registerLanguageDictionary(deDE);

const cashbackTypes = [
  { name: "Проценты", value: "percent" },
  { name: "Сумма", value: "const" },
  { name: "Без кэшбэка", value: "no_cashback" },
  { name: "По карте лояльности", value: "lcard_cashback" },
]; //["percent", "percent", "const", "no_cashback", "lcard_cashback"];

export default function TableDocsPurchases() {
  const [searchParams] = useSearchParams();
  const hotTableRef = useRef(null);
  const [data, setData] = useState([]);
  const [changeCount, setChangeCount] = useState(0);
  const [messageApi, contextHolder] = message.useMessage();
  const [filterForm] = Form.useForm();
  const [filters, setFilters] = useState({
    id: "",
    name: "",
    type: "",
    description_short: "",
    description_long: "",
    code: "",
    unit_name: null,
    category: null,
    manufacturer: null,
    barcode: "",
    cashback_type: null,
    cashback_value_from: "",
    cashback_value_to: "",
  });
  const { Panel } = Collapse;
  const queryClient = useQueryClient();
  const afterChangeTimeoutRef = useRef(null);

  // const queryKeys = queryClient.getQueryCache();

  const { token, websocket } = useContext(PricesHandsontableContext);
  const {
    isLoading: isLoadingPrices,
    isError: isErrorPrices,
    data: prices,
  } = useFetchAllPrices({ token });
  const {
    isLoading: isLoadingNomenclatures,
    isError: isErrorNomenclatures,
    data: nomenclatures = [],
    isSuccess: isSuccessNomenclatures,
  } = useFetchAllNomenclature({ token });

  const {
    isLoading: isLoadingPriceTypes,
    isError: isErrorPriceTypes,
    data: priceTypes,
  } = useFetchAllPricesType({ token });
  const {
    isLoading: isLoadingManufactures,
    isError: isErrorManufactures,
    data: manufactures,
    isSuccess: isSuccessManufactures,
  } = useFetchAllManufacturers({ token });
  const {
    isLoading: isLoadingUnits,
    isError: isErrorUnits,
    data: units,
  } = useFetchAllUnits();

  const {
    isLoading: isLoadingCategories,
    isError: isErrorCategories,
    data: categories,
    isSuccess: isSuccessCategories,
    refetch: refetchCategories,
  } = useFetchAllCategories({ token });
  const [
    mutateEditNomenclatures,
    { isLoading: isLoadingEdit, isError: isErrorEdit, isSucces: isSuccessEdit },
  ] = useFetchEditNomenclature(token);

  const [
    _,
    {
      isLoading: isLoadingCreate,
      isError: isErrorCreate,
      isSucces: isSuccessCreate,
      mutateAsync: mutateAsyncCreateNomenclature,
    },
  ] = useFetchCreateNomenclature(token);

  const [
    mutateDeleteNomenclatures,
    {
      isLoading: isLoadingDelete,
      isError: isErrorDelete,
      isSuccess: isSuccesDelete,
    },
  ] = useFetchDeleteNomenclature(token);

  const [
    mutateDeletePrices,
    {
      isLoading: isLoadingDeletePrices,
      isError: isErrorDeletePrices,
      isSuccess: isSuccesDeletePrices,
    },
  ] = useFetchDeletePrices(token);

  const [
    mutateCreatePrices,
    { isLoading: isLoadingCreatePrices, isError: isErrorCreatePrices },
  ] = useFetchCreatePrice(token);

  const [
    mutateEditPrice,
    { isLoading: isLoadingEditPrice, isError: isErrorEditPrice },
  ] = useFetchEditPrice(token);

  const { rowRenderer, handleScroll } = useVirtualization();

  const isLoading =
    isLoadingPrices ||
    isLoadingNomenclatures ||
    isLoadingPriceTypes ||
    isLoadingManufactures ||
    isLoadingUnits ||
    isLoadingCategories ||
    isLoadingEdit ||
    isLoadingCreate ||
    isLoadingDelete ||
    isLoadingCreatePrices ||
    isLoadingEditPrice;

  const isError =
    isErrorPrices ||
    isErrorNomenclatures ||
    isErrorPriceTypes ||
    isErrorManufactures ||
    isErrorUnits ||
    isErrorCategories ||
    isErrorEdit ||
    isErrorCreate ||
    isErrorDelete ||
    isErrorCreatePrices ||
    isErrorEditPrice;
  if (isError) console.log("isError");

  const manumafacturesById = convertArrayToObject(manufactures);
  const manumafacturesByValue = reversedObj(manumafacturesById);

  const categoriesById = convertArrayToObject(categories);
  const categoriesByValue = reversedObj(categoriesById);

  const unitsByValue = convertUnitsToObjectByValue(units);

  const preparePrices = getPreparePrices(prices);

  const filteredData = useMemo(() => {
    if (!data || !data.length) return data;

    return data.filter((row) => {
      if (filters.id) {
        const idStr = String(row.id ?? "");
        if (idStr !== String(filters.id).trim()) {
          return false;
        }
      }

      if (filters.name) {
        const name = String(row.name || "").toLowerCase();
        if (!name.includes(filters.name.toLowerCase())) {
          return false;
        }
      }

      if (filters.type) {
        const type = String(row.type || "").toLowerCase();
        if (!type.includes(filters.type.toLowerCase())) {
          return false;
        }
      }

      if (filters.description_short) {
        const desc = String(row.description_short || "").toLowerCase();
        if (!desc.includes(filters.description_short.toLowerCase())) {
          return false;
        }
      }

      if (filters.description_long) {
        const desc = String(row.description_long || "").toLowerCase();
        if (!desc.includes(filters.description_long.toLowerCase())) {
          return false;
        }
      }

      if (filters.code) {
        const code = String(row.code || "").toLowerCase();
        if (!code.includes(filters.code.toLowerCase())) {
          return false;
        }
      }

      if (filters.unit_name) {
        const unitName = String(row.unit_name || "").toLowerCase();
        if (unitName !== filters.unit_name.toLowerCase()) {
          return false;
        }
      }

      if (filters.category) {
        const category = String(row.category || "").toLowerCase();
        if (category !== filters.category.toLowerCase()) {
          return false;
        }
      }

      if (filters.manufacturer) {
        const manufacturer = String(row.manufacturer || "").toLowerCase();
        if (manufacturer !== filters.manufacturer.toLowerCase()) {
          return false;
        }
      }

      if (filters.barcode) {
        const barcode = String(row.barcode || "").toLowerCase();
        if (!barcode.includes(filters.barcode.toLowerCase())) {
          return false;
        }
      }

      if (filters.cashback_type) {
        const type = String(row.cashback_type || "").toLowerCase();
        if (type !== filters.cashback_type.toLowerCase()) {
          return false;
        }
      }

      if (filters.cashback_value_from || filters.cashback_value_to) {
        const value = Number(row.cashback_value ?? NaN);
        if (!Number.isNaN(value)) {
          if (
            filters.cashback_value_from !== "" &&
            value < Number(filters.cashback_value_from)
          ) {
            return false;
          }
          if (
            filters.cashback_value_to !== "" &&
            value > Number(filters.cashback_value_to)
          ) {
            return false;
          }
        }
      }

      return true;
    });
  }, [data, filters]);

  useEffect(() => {
    if (
      (isSuccessNomenclatures &&
        isSuccessManufactures &&
        nomenclatures &&
        prices) ||
      isError
    ) {
      const newData = nomenclatures.map((item) => {
        const prices = preparePrices[item?.id] || {};
        const newBarcode =
          item?.barcodes && item.barcodes.length > 0 ? item.barcodes[0] : null;
        const existingDataIndex = data.findIndex((d) => d.id === item.id);
        if (existingDataIndex !== -1) {
          return {
            ...data[existingDataIndex],
            ...prices,
            category: categoriesById[item?.category],
            barcode:
              newBarcode !== null
                ? newBarcode
                : data[existingDataIndex].barcode,
          };
        } else {
          return {
            ...item,
            ...prices,
            manufacturer: manumafacturesById[item?.manufacturer],
            category: categoriesById[item?.category],
            barcode:
              item?.barcodes && item.barcodes.length > 0
                ? item.barcodes[0]
                : null,
          };
        }
      });
      if (data.length === 0) setData(newData.length ? newData : [{}]);
    }
  }, [
    isSuccessNomenclatures,
    isSuccessManufactures,
    isSuccessCategories,
    isSuccessEdit,
    isSuccessCreate,
    changeCount,
    nomenclatures,
    prices,
    isError,
    preparePrices,
    categoriesById,
  ]);

  useEffect(() => {
    websocket.onmessage = (message) => {
      const data = JSON.parse(message.data);
      if (data.target === "nomenclature" && data.action === "edit") {
        const editNomenclature = data.result;
        const unit_name =
          editNomenclature?.unit_name ||
          units?.find(({ id }) => id === editNomenclature.unit)
            ?.convent_national_view;

        const editId = editNomenclature.id;
        queryClient.setQueriesData("nomenclature", (oldData) => {
          return oldData?.map((item) =>
            item.id === editId ? { ...editNomenclature, unit_name } : item
          );
        });
      }
      if (data.target === "nomenclature" && data.action === "delete") {
        const deleteId = data.result.id;
        queryClient.setQueriesData("nomenclature", (oldData) => {
          const newData = oldData.filter((item) =>
            item.id === deleteId ? false : true
          );
          return newData;
        });
      }
      if (data.target === "nomenclature" && data.action === "create") {
        queryClient.setQueriesData("nomenclature", (oldData) => {
          const newData = oldData.concat(
            data?.result?.map((item) => {
              const unit_name = units?.find(
                ({ id }) => id === item.unit
              )?.convent_national_view;
              return { ...item, unit_name };
            })
          );
          return newData;
        });
      }
      if (data.target === "prices" && data.action === "edit") {
        const editPrices = data.result;
        const editId = editPrices.id;
        queryClient.setQueriesData("prices", (oldData) => {
          return oldData.map((item) =>
            item.id === editId ? editPrices : item
          );
        });
      }
      if (data.target === "prices" && data.action === "create") {
        queryClient.setQueriesData("prices", (oldData) => {
          const newData = oldData.concat(data.result);
          return newData;
        });
      }
      setChangeCount((prev) => prev++);
    };
  }, [token, units]);

  const addRow = () => {
    setData((prevData) => [
      ...prevData,
      {
        name: "",
        type: "",
        description_short: "",
        description_long: "",
        code: "",
        unit: "",
        category: "",
        manufacturer: "",
        unit_name: "",
      },
    ]);
  };

  const afterChange = async (changes, source) => {
    if (afterChangeTimeoutRef.current) {
      clearTimeout(afterChangeTimeoutRef.current);
    }

    afterChangeTimeoutRef.current = setTimeout(async () => {
      const coords = hotTableRef?.current?.hotInstance.getSelected();
      const left = coords?.[0]?.[1];
      if (left === -1) return;
      
      // Проверка на пустые изменения
      if (!changes || changes.length === 0) {
        console.log('[afterChange] Нет изменений для обработки');
        return;
      }

      const realChanges = changes.filter(([row, prop, oldValue, newValue]) => {
        const hasChanged = oldValue !== newValue;
        if (!hasChanged) {
          console.log(`[afterChange] Пропуск изменения в строке ${row}, поле ${prop}: значения одинаковые`);
        }
        return hasChanged;
      });

      if (realChanges.length === 0) {
        console.log('[afterChange] Нет реальных изменений для обработки');
        return;
      }

      const changeType = getChangeType(realChanges, priceTypes);

      console.log(`[afterChange] Источник: ${source}, Тип изменений: ${changeType}, Количество изменений: ${realChanges.length}`);
      console.log('[afterChange] Детали изменений:', realChanges.map(([row, prop, oldValue, newValue]) => ({
        row,
        prop,
        oldValue,
        newValue,
        changed: oldValue !== newValue
      })));

      if (
        source === "edit" ||
        source === "CopyPaste.paste" ||
        source === "Autofill.fill"
      ) {
        const hideLoading = messageApi.loading("Сохраняем изменения...", 0);
        try {
          const changeBarcodes = [];
          const updatedData = [...data];
          let itemId = null;
          realChanges.forEach(([row, prop, oldValue, newValue]) => {
            updatedData[row][prop] = newValue;
            updatedData[row]["updated"] = oldValue !== newValue;
            if (prop === "barcode") {
              const changedItem = updatedData[row];
              itemId = changedItem.id;
              const updatedBarcode = newValue;
              const oldBarcode = oldValue;
              changeBarcodes.push({
                idx: itemId,
                old_barcode: oldBarcode,
                new_barcode: updatedBarcode,
              });
            }
          });

          const updatedRows = updatedData.filter(row => row.updated);
          console.log(`[afterChange] Обновлено строк: ${updatedRows.length}`, updatedRows);

          if (changeBarcodes.length > 0) {
            const barcodeLoading = messageApi.loading("Обновляем штрихкоды...", 0);
            try {
              await axios
                .patch(
                  `https://${process.env.REACT_APP_APP_URL}/api/v1/nomenclature/barcode?token=${token}`,
                  changeBarcodes
                )
                .then(() => {
                  setData([...updatedData]);
                });
              messageApi.success("Штрихкоды успешно обновлены", 2.5);
            } catch (err) {
              messageApi.error("Ошибка при обновлении штрихкодов", 2.5);
            } finally {
              barcodeLoading();
            }
          }

          let createdCategories = {};
          for (let change of realChanges) {
            const [row, prop, oldValue, newValue] = change;
            if (
              prop === "category" &&
              !createdCategories[newValue] &&
              !categoriesByValue[newValue] &&
              newValue
            ) {
              const catLoading = messageApi.loading("Создаём категорию...", 0);
              try {
                const response = await apiRequests.categories.post([
                  {
                    name: newValue,
                    status: true,
                  },
                ]);
                updatedData[row].category = response.data[0].name;
                createdCategories[response.data[0].name] = response.data[0].id;
                messageApi.success("Категория создана", 2.5);
              } catch (err) {
                messageApi.error("Ошибка при создании категории", 2.5);
              } finally {
                catLoading();
              }
            }
          }

          if (Object.keys(createdCategories).length) {
            const refetchLoading = messageApi.loading("Обновляем категории...", 0);
            try {
              await refetchCategories();
              messageApi.success("Категории обновлены", 2.5);
            } catch (err) {
              messageApi.error("Ошибка при обновлении категорий", 2.5);
            } finally {
              refetchLoading();
            }
          }

          const normalizeName = (name) => {
            return typeof name === 'string' 
              ? name.trim().toLowerCase() 
              : String(name || '').trim().toLowerCase();
          };

          const existingNames = new Set(
            data
              .filter(row => row.id)
              .map(row => normalizeName(row.name))
          );

          const createRows = [];
          const editRows = [];
          
          updatedData
            .filter((row) => row.updated)
            .forEach(({ updated, manufacturer, cashback_type, ...rest }, index) => {
              let cashbackValue = "no_cashback";
              if (cashback_type) {
                const foundType = cashbackTypes.find(
                  (item) => item.name === cashback_type
                );
                cashbackValue = foundType ? foundType.value : "no_cashback";
              }
              
              const transformed = {
                ...rest,
                cashback_type: cashbackValue,
                manufacturer: +manumafacturesByValue[manufacturer],
                unit: unitsByValue[rest?.unit_name],
                category:
                  typeof rest?.category === "number"
                    ? rest?.category
                    : createdCategories[rest?.category] ||
                      +categoriesByValue[rest?.category],
              };
              
              if (typeof transformed?.id === "number") {
                editRows.push({
                  data: transformed,
                  original: data.find(item => item.id === transformed.id),
                  index
                });
              } else {
                createRows.push({
                  data: transformed,
                  index
                });
              }
            });

          console.log(`[afterChange] Подготовлено для редактирования: ${editRows.length}, для создания: ${createRows.length}`);

          const validCreateRows = [];
          const createNamesMap = new Map();
          
          for (const row of createRows) {
            const name = normalizeName(row.data.name);
            if (!name) continue;
            
            if (existingNames.has(name)) {
              console.log(`[Дубликат CREATE] Имя "${row.data.name}" существует в БД. Пропуск.`);
              continue;
            }
            
            if (createNamesMap.has(name)) {
              console.log(`[Дубликат CREATE] Имя "${row.data.name}" дублируется в пакете. Пропуск.`);
              continue;
            }
            
            createNamesMap.set(name, true);
            validCreateRows.push(row);
          }

          const validEditRows = [];
          const editNamesMap = new Map();
          
          for (const row of editRows) {
            const name = normalizeName(row.data.name);
            const originalName = normalizeName(row.original?.name);
            
            if (name === originalName) {
              validEditRows.push(row);
              continue;
            }
            
            if (!name) continue;
        
            const nameExists = data.some(
              item => 
                item.id !== row.data.id && 
                normalizeName(item.name) === name
            );
            
            if (nameExists) {
              console.log(`[Дубликат EDIT] Имя "${row.data.name}" существует в БД. Пропуск.`);
              continue;
            }
            
            if (createNamesMap.has(name)) {
              console.log(`[Дубликат EDIT] Имя "${row.data.name}" конфликтует с новой строкой. Пропуск.`);
              continue;
            }
            
            if (editNamesMap.has(name)) {
              console.log(`[Дубликат EDIT] Имя "${row.data.name}" дублируется в пакете. Пропуск.`);
              continue;
            }
            
            editNamesMap.set(name, true);
            validEditRows.push(row);
          }

          console.log(`[afterChange] Валидных для редактирования: ${validEditRows.length}, для создания: ${validCreateRows.length}`);

          const editData = validEditRows.map(row => row.data);
          const createData = validCreateRows.map(row => row.data);
          
          const { editPrice = [], createPrice = [] } = getPriceListForEditFetch(
            editData,
            priceTypes,
            prices
          );

          if (
            editData.length &&
            (changeType === ChangeTypes.Complex ||
              changeType === ChangeTypes.Nomenclature)
          ) {
            const editLoading = messageApi.loading("Редактируем номенклатуру...", 0);
            try {
              await mutateEditNomenclatures(editData);
              console.log(`[afterChange] Успешно отредактировано: ${editData.length} записей`);
              messageApi.success("Номенклатура успешно отредактирована", 2.5);
            } catch (err) {
              console.error('[afterChange] Ошибка редактирования:', err);
              messageApi.error("Ошибка при редактировании номенклатуры", 2.5);
            } finally {
              editLoading();
            }
          }
          
          if (
            createData.length &&
            (changeType === ChangeTypes.Complex ||
              changeType === ChangeTypes.Nomenclature)
          ) {
            const createLoading = messageApi.loading("Создаём номенклатуру...", 0);
            try {
              const newNomenclature = await mutateAsyncCreateNomenclature(
                createData,
                priceTypes
              );
              console.log(`[afterChange] Успешно создано: ${createData.length} записей`);
              messageApi.success("Номенклатура успешно создана", 2.5);
              const raw = newNomenclature?.data ?? newNomenclature;
              const arr = Array.isArray(raw) ? raw : (raw?.result ?? raw?.data ?? []);
              const createdItems = Array.isArray(arr) ? arr : [arr];
              const createRowsWithId = createData.map((row, index) => ({
                ...row,
                id: createdItems[index]?.id ?? createdItems[index],
              }));
              const priceCreateList =
                getPriceListForCreateFetch(createRowsWithId, priceTypes) || [];
              if (
                priceCreateList.length &&
                (changeType === ChangeTypes.Complex ||
                  changeType === ChangeTypes.Price)
              ) {
                const priceCreateLoading = messageApi.loading("Создаём цены...", 0);
                try {
                  await mutateCreatePrices(priceCreateList);
                  messageApi.success("Цены успешно созданы", 2.5);
                } catch (err) {
                  messageApi.error("Ошибка при создании цен", 2.5);
                } finally {
                  priceCreateLoading();
                }
              }
            } catch (err) {
              console.error('[afterChange] Ошибка создания:', err);
              messageApi.error("Ошибка при создании номенклатуры", 2.5);
            } finally {
              createLoading();
            }
          }
          
          if (
            createPrice.length &&
            (changeType === ChangeTypes.Complex ||
              changeType === ChangeTypes.Price)
          ) {
            const createPriceLoading = messageApi.loading("Создаём цены...", 0);
            try {
              await mutateCreatePrices(createPrice);
              messageApi.success("Цены успешно созданы", 2.5);
            } catch (err) {
              messageApi.error("Ошибка при создании цен", 2.5);
            } finally {
              createPriceLoading();
            }
          }

          if (
            editPrice.length &&
            (changeType === ChangeTypes.Complex ||
              changeType === ChangeTypes.Price)
          ) {
            const editPriceLoading = messageApi.loading("Редактируем цены...", 0);
            try {
              await mutateEditPrice(editPrice);
              messageApi.success("Цены успешно отредактированы", 2.5);
            } catch (err) {
              messageApi.error("Ошибка при редактировании цен", 2.5);
            } finally {
              editPriceLoading();
            }
          }

          const rejectedRows = [
            ...createRows.filter(row => !validCreateRows.includes(row)),
            ...editRows.filter(row => !validEditRows.includes(row))
          ];

          if (rejectedRows.length) {
            console.log(`[afterChange] Отклонено строк: ${rejectedRows.length}`, rejectedRows);
            let hasChanges = false;
            rejectedRows.forEach(rowInfo => {
              const rowIndex = rowInfo.index;
              const originalName = rowInfo.original?.name || '';
              if (updatedData[rowIndex].name !== originalName) {
                updatedData[rowIndex].name = originalName;
                hasChanges = true;
                messageApi.warning(`Строка "${rowInfo.data.name}" не сохранена: дубликат имени`, 2.5);
              }
            });
            if (hasChanges) {
              setData([...updatedData]);
            }
          }
        } catch (err) {
          console.error('[afterChange] Общая ошибка:', err);
          messageApi.error("Ошибка при сохранении изменений", 2.5);
        } finally {
          hideLoading?.();
        }
      }
    }, 300); 
  };

  useEffect(() => {
    return () => {
      if (afterChangeTimeoutRef.current) {
        clearTimeout(afterChangeTimeoutRef.current);
      }
    };
  }, []);

  const handleAfterRemoveRow = async (_, __, indexes) => {
    const hideLoading = messageApi.loading("Удаляем...", 0);
    try {
      const removedIds = indexes
        .map((index) => {
          const nomenclature = nomenclatures[index];
          return nomenclature?.id || null;
        })
        .filter((item) => item !== null);
      if (removedIds.length) {
        const delNomenLoading = messageApi.loading("Удаляем номенклатуру...", 0);
        try {
          await mutateDeleteNomenclatures(removedIds);
          messageApi.success("Номенклатура успешно удалена", 2.5);
        } catch (err) {
          messageApi.error("Ошибка при удалении номенклатуры", 2.5);
        } finally {
          delNomenLoading();
        }
        const deletePrices = prices
          .filter((price) =>
            removedIds.some((item) => item === price.nomenclature_id)
          )
          .map((item) => item.id);
        if (deletePrices.length) {
          const delPriceLoading = messageApi.loading("Удаляем цены...", 0);
          try {
            await mutateDeletePrices(deletePrices);
            messageApi.success("Цены успешно удалены", 2.5);
          } catch (err) {
            messageApi.error("Ошибка при удалении цен", 2.5);
          } finally {
            delPriceLoading();
          }
        }
      }
      messageApi.success("Удаление прошло успешно", 2.5);
    } catch (err) {
      messageApi.error("Ошибка при удалении", 2.5);
    } finally {
      hideLoading?.();
    }
  };

  const handleDeleteKeyPress = (event) => {
    event.stopImmediatePropagation();
    if (event.code === "Delete" || event.code === "Backspace") {
      const coords = hotTableRef.current.hotInstance.getSelected(); //[[top, left,bottom,right]]
      const [top, left, bottom] = coords?.[0];
      if (left === -1) {
        const deleteNomenclatures = data
          .slice(top, bottom + 1)
          ?.map(({ id }) => id);
        if (deleteNomenclatures.length) {
          mutateDeleteNomenclatures(deleteNomenclatures);
          const deletePrices = prices
            .filter((price) =>
              deleteNomenclatures.some((item) => item === price.nomenclature_id)
            )
            .map((item) => item.id);
          if (deletePrices.length) mutateDeletePrices(deletePrices);
        }
      }
    }
  };

  const handleFilterSubmit = (values) => {
    setFilters({
      id: values.id || "",
      name: values.name || "",
      type: values.type || "",
      description_short: values.description_short || "",
      description_long: values.description_long || "",
      code: values.code || "",
      unit_name: values.unit_name || null,
      category: values.category || null,
      manufacturer: values.manufacturer || null,
      barcode: values.barcode || "",
      cashback_type: values.cashback_type || null,
      cashback_value_from: values.cashback_value_from || "",
      cashback_value_to: values.cashback_value_to || "",
    });
  };

  const handleFilterReset = () => {
    filterForm.resetFields();
    setFilters({
      id: "",
      name: "",
      type: "",
      description_short: "",
      description_long: "",
      code: "",
      unit_name: null,
      category: null,
      manufacturer: null,
      barcode: "",
      cashback_type: null,
      cashback_value_from: "",
      cashback_value_to: "",
    });
  };

  return (
    <>
      {contextHolder}

      <div style={{ marginBottom: 12 }}>
        <Collapse ghost>
          <Panel header="Фильтры данных номенклатуры" key="1">
            <Form
              form={filterForm}
              layout="inline"
              style={{
                width: "100%",
                marginBottom: "12px",
                rowGap: "12px",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "flex-start",
              }}
              onFinish={handleFilterSubmit}
            >
              <Form.Item name="id" label="ID">
                <Input placeholder="id" allowClear style={{ width: 120 }} />
              </Form.Item>

              <Form.Item name="name" label="Название">
                <Input placeholder="название" allowClear />
              </Form.Item>

              <Form.Item name="type" label="Тип">
                <Input placeholder="тип" allowClear />
              </Form.Item>

              <Form.Item name="description_short" label="Короткое описание">
                <Input placeholder="короткое описание" allowClear />
              </Form.Item>

              <Form.Item name="description_long" label="Описание">
                <Input placeholder="описание" allowClear />
              </Form.Item>

              <Form.Item name="code" label="Код">
                <Input placeholder="код" allowClear style={{ width: 140 }} />
              </Form.Item>

              <Form.Item name="unit_name" label="Единица">
                <Select
                  allowClear
                  style={{ minWidth: 180 }}
                  options={(units || []).map((item) => ({
                    value: item?.convent_national_view,
                    label: item?.convent_national_view,
                  }))}
                />
              </Form.Item>

              <Form.Item name="category" label="Категория">
                <Select
                  allowClear
                  style={{ minWidth: 200 }}
                  options={(categories || []).map((item) => ({
                    value: item?.name,
                    label: item?.name,
                  }))}
                />
              </Form.Item>

              <Form.Item name="manufacturer" label="Производитель">
                <Select
                  allowClear
                  style={{ minWidth: 200 }}
                  options={(manufactures || []).map((item) => ({
                    value: item?.name,
                    label: item?.name,
                  }))}
                />
              </Form.Item>

              <Form.Item name="barcode" label="Штрих‑код">
                <Input placeholder="штрих‑код" allowClear />
              </Form.Item>

              <Form.Item name="cashback_type" label="Тип кэшбэка">
                <Select
                  allowClear
                  style={{ minWidth: 200 }}
                  options={cashbackTypes.map((item) => ({
                    value: item.value,
                    label: item.name,
                  }))}
                />
              </Form.Item>

              <Form.Item name="cashback_value_from" label="Кэшбэк от">
                <Input
                  type="number"
                  placeholder="от"
                  style={{ width: 120 }}
                />
              </Form.Item>

              <Form.Item name="cashback_value_to" label="до">
                <Input
                  type="number"
                  placeholder="до"
                  style={{ width: 120 }}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginRight: 8 }}
                >
                  Поиск
                </Button>
                <Button danger onClick={handleFilterReset}>
                  Очистить
                </Button>
              </Form.Item>
            </Form>
          </Panel>
        </Collapse>
      </div>

      <div className="htb">
        <HotTable
          // columnSorting={{
          //   initialConfig: {
          //     column: 0,
          //     sortOrder: "asc",
          //   },
          // }}
          style={{
            overflow: "hidden",
            height: searchParams.get("hideLayout") ? "100vh" : "85vh",
          }}
          ref={hotTableRef}
          className={"contragents-table__td htCenter htMiddle"}
          rowHeights={"65px"}
          columnHeaderHeight={"65px"}
          licenseKey="non-commercial-and-evaluation"
          autoRowSize={true}
          autoColumnSize={true}
          rowHeaders={true}
          contextMenu
          data={filteredData}
          rowRenderer={rowRenderer}
          stretchH="all"
          stretchV="all"
          viewportRowRenderingOffset={20}
          onScrollVertically={handleScroll}
          dropdownMenu
          // language="ru-RU"
          filters
          afterDocumentKeyDown={handleDeleteKeyPress}
          afterRemoveRow={handleAfterRemoveRow}
          afterChange={afterChange}
        >
          <HotColumn data="id" title="id" readOnly={true} />
          <HotColumn data="name" title="Название" />
          <HotColumn data="type" title="Тип" />
          <HotColumn data="description_short" title="Короткое описание" />
          <HotColumn data="description_long" title="Описание" />
          <HotColumn data="code" title="Код" />
          <HotColumn
            data="unit_name"
            title="Еденица измерения"
            type="dropdown"
            source={units?.map((item) => item?.convent_national_view)}
          />
          <HotColumn
            data="category"
            title="Категория"
            type="autocomplete"
            source={categories?.map((item) => item?.name)}
          />
          <HotColumn
            data="manufacturer"
            title="Производитель"
            type="dropdown"
            source={manufactures?.map((item) => item?.name)}
          />
          {priceTypes?.map(({ name, id }) => (
            <HotColumn data={name} title={name} key={id} />
          ))}
          <HotColumn data={"barcode"} title={"Штрих-код"} />
          <HotColumn
            data={"cashback_type"}
            title={"Тип кэшбека"}
            type="dropdown"
            source={cashbackTypes.map((item) => item.name)}
            renderer={(instance, td, row, col, prop, value) => {
              const type = cashbackTypes.find((item) => item.value === value);
              td.textContent = type ? type.name : value;
              return td;
            }}
          />
          <HotColumn data={"cashback_value"} title={"Значение кэшбека"} />
        </HotTable>
      </div>
    </>
  );
}
